/* eslint-disable no-useless-escape */
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import _ from 'lodash';

gsap.registerPlugin(ScrollToPlugin);

export default {
  init() {
    // JavaScript to be fired on all pages

    let anchorLinks = document.querySelectorAll('.anchor-link');
    if (anchorLinks) {
      anchorLinks.forEach(a => {
        var clicked = 0;
        a.addEventListener('click', (e) => {
          e.preventDefault();
          let href = e.target.hash;
          gsap.to(window, {
            duration: 1,
            scrollTo: href,
          });
          if(clicked == 0) {
            clicked ++;
            a.click();
          }
        });
      });
    }

    let anchors = document.querySelectorAll('a[href*="#"].link');
    if (anchors) {
      anchors.forEach(a => {
        var clicked = 0;
        a.addEventListener('click', (e) => {
          e.preventDefault();
          let href = e.target.hash;
          gsap.to(window, {
            duration: 1,
            scrollTo: href,
          });
          if(clicked == 0) {
            clicked ++;
            a.click();
          }
        });
      });
    }

    let sections = document.querySelectorAll('section');
    if(sections) {
      addEventListener('scroll', () => {
        sections.forEach(section => {
          const section_height = section.offsetHeight;
          var section_id = section.getAttribute('data-menu'),
              section_top = section.getBoundingClientRect().top,
              section_visible = section_height + section_top;
          if(document.querySelector('.menu-item a[href="#' + section_id + '"]') != 'null' && document.querySelector('.menu-item a[href="#' + section_id + '"]') != undefined) {
            if(section_top < 20 && section_visible > 20) {
              document.querySelector('.menu-item a[href="#' + section_id + '"]').classList.add('active');
            } else {
              document.querySelector('.menu-item a[href="#' + section_id + '"]').classList.remove('active');
            }
          }
          
        })
      });
    }

    let menuanchors = document.querySelectorAll('.menu-item a');
    if (menuanchors) {
      menuanchors.forEach(a => {
        var clicked = 0;
        a.addEventListener('click', (e) => {
          e.preventDefault();
          let href = e.target.hash;
          gsap.to(window, {
            duration: 1,
            scrollTo: href,
          });
          if(clicked == 0) {
            clicked ++;
            a.click();
          }
        });
      });
    }

    $('.collapse').on('show.bs.collapse', function () {

      gsap.fromTo($(this).siblings('.icon'), {
        autoAlpha: 0,
      },{
        autoAlpha: 1,
        duration: 0.5,
        delay: 0.3,
      });
      $(this).addClass('current');
      $(this).parent('.accordion-item').addClass('open');
    });

    $('.collapse').on('hide.bs.collapse', function () {
      if ($(this).hasClass('current')) {
        gsap.to($(this).siblings('.icon'), {
          autoAlpha: 0,
          duration: 0.15,
          overwrite: true,
        });
        $(this).removeClass('current');
        $(this).parent('.accordion-item').removeClass('open');
      }
    });

    $('[data-industry]').on('click', function(e) {
      $('[data-industry]').removeClass('active');
      $(e.target).addClass('active');

      let industry = $(e.target).data('industry');

      $('[data-client-industry]').each((i, e) => {

        let clientIndustries = $(e).data('client-industry').trim().split(' ');

        let industryCheck = clientIndustries.filter((ci => ci == industry));

        if (industryCheck.length > 0) {
          $(e).removeClass('fade');
        } else {
          $(e).addClass('fade');
        }

      });
    });

    let groupButtons = document.querySelectorAll('.top-section--btn-group .btn');
    if (groupButtons) {
      groupButtons.forEach(a => {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          let href = e.target.hash;
          gsap.to(window, {
            duration: 1,
            scrollTo: {
              y: href,
              offsetY: 50,
            },
          });
        });
      });
    }

    let formDropdown = document.querySelectorAll('.has__dropdown');
    formDropdown.forEach(d => {
      let input = d.querySelector('input');

      let optionClick = (e) => {
        input.value = e.target.innerText;
        if (budget) {
          if(e.target.innerText == 'New project') {
            budget.classList.remove('is-hidden');
          } else {
            budget.classList.add('is-hidden');
          }
        }
        input.classList.remove('is-focus');
        input.classList.add('has__value');
        document.removeEventListener('click', closeDropdown);
      };

      let closeDropdown = (e) => {
        let click = false;
        formDropdown.forEach(fd => {
          let dropdown = fd.querySelector('.form__dropdown');
          if (e.target == dropdown || dropdown.contains(e.target)) {
            click = true; 
          }
        });
  
        if (!click) {
          formDropdown.forEach(fd => {
            let input = fd.querySelector('input');
            if (input.classList.contains('is-focus')) {
              input.classList.remove('is-focus');
              document.removeEventListener('click', closeDropdown);
            }
          });
        } else {
          formDropdown.classList.add('is_open');
        }
      };

      input.addEventListener('click', (e) => {
        e.stopPropagation();
        if (input.classList.contains('is-focus')) {
          closeDropdown(e);

        } else {
          input.classList.add('is-focus');
          let listItems = d.querySelectorAll('span');
          listItems.forEach(l => {
            l.addEventListener('click', optionClick);
          });
          document.addEventListener('click', closeDropdown);
        }
      });

    });    

    let budget = document.getElementById('budget');
    if (typeof(budget) != 'undefined' && budget != null) {
      budget.classList.add('is-hidden');
    }

    

    $(document).ready(function(){
      $('input, textarea').blur(function(){
          if($(this).val()){
            $(this).addClass('has__value');
          } else{
            $(this).removeClass('has__value');
          }
      });
    });

    let formAbandon = [];
    let formAttribute = 'name';
    
    window.addEventListener('beforeunload', () => {
      // console.log(formAbandon.join(' > '));
      if (formAbandon.length) {
        window.dataLayer.push({
          'event' : 'formAbandoned',
          'eventCategory' : 'Form Abandoned',
          'eventAction' : document.title, 
          'eventLabel' : formAbandon.join(' > '),
        });
      }
    });


    let resourceForm = document.querySelector('form.top-section--cta-form');

    if (resourceForm) {
      let resourceLink = resourceForm.querySelector('[data-value]').dataset.value;

      resourceForm.querySelectorAll('[data-value]').forEach(r => {
        r.addEventListener('click', () => {
          resourceLink = r.dataset.value;
        });
      });

      resourceForm.addEventListener('submit', (e) => {
        e.preventDefault();
        window.location.href = '//' + window.location.host + window.location.pathname + '/' + resourceLink;
      });
    }

    let contactForm = document.querySelector('form.contact__form');

    if (contactForm) {
      let formType = contactForm.querySelector('input[name=form-type]');

      contactForm.addEventListener('change', function(e) {
        formAbandon.push(e.target.getAttribute(formAttribute));

        if (formType.value == 'adwords') {
          window.dataLayer.push({
            'event' : 'formInteraction',
            'eventCategory' : 'Form Interaction',
            'eventAction' : formType.value + ' landing Contact Form',
            'eventLabel' : e.target.getAttribute(formAttribute),
          });

        } else if (formType.value == 'adaptive-business') {
          window.dataLayer.push({
            'event' : 'formInteraction',
            'eventCategory' : 'Form Interaction',
            'eventAction' : 'Adaptive Business Contact Form',
            'eventLabel' : e.target.getAttribute(formAttribute),
          });

        } else {
          window.dataLayer.push({
            'event' : 'formInteraction',
            'eventCategory' : 'Form Interaction',
            'eventAction' : 'Contact Form',
            'eventLabel' : e.target.getAttribute(formAttribute),
          });
        }
      });

      contactForm.addEventListener('submit', (e) => {
        e.preventDefault();
  
        window.grecaptcha.ready(function() {
          window.grecaptcha.execute('6LeONPYUAAAAAOCBFJO2SdIXOW4nBsb-FvjDwsRD', {action: 'submitForm'})
          .then(function(token) {
            document.getElementById('main-g-recaptcha-response').value = token;
  
            let countError = 0;
      
            let removeError = (e) => {
              e.target.parentElement.classList.remove('has-error');
              e.target.removeEventListener('click', removeError);
            };
      
            let addErrorClass = (element, msg) => {
              countError = ++countError;
              element.parentElement.classList.add('has-error');
              element.parentElement.parentElement.querySelector('.form__error').textContent = msg;
              element.addEventListener('click', removeError);
            };
      
            let successDialog = document.querySelector('.form-container .form__success');
      
            let nonce = contactForm.querySelector('input[name=nonce]');
            let adwordsType = contactForm.querySelector('input[name=adwords-type]');
            let recaptcha = contactForm.querySelector('input[name=g-recaptcha-response]');
            let firstName = contactForm.querySelector('input[name=first-name]');
            let lastName = contactForm.querySelector('input[name=last-name]');
            let company = contactForm.querySelector('input[name=company]');
            let email = contactForm.querySelector('input[name=email]');
            let phone = contactForm.querySelector('input[name=phone]');
            let businessType = contactForm.querySelector('input[name=business-type]');
            let services = contactForm.querySelectorAll('input[name=services]:checked');
            let enquiryType = contactForm.querySelector('input[name=enquiry-type]');
            let budget = contactForm.querySelector('input[name=budget]');
            let message = contactForm.querySelector('textarea[name=tell-us-more]');
            let privacy = contactForm.querySelector('input[name=privacy]');
            let button = contactForm.querySelector('button[type=submit]');

            let servicesValues = [];
      
            if (firstName) {
              if ( isEmpty(firstName.value) ) {
                addErrorClass(firstName, 'Please fill in your first name');
              }
            }
            if (lastName) {
              if ( isEmpty(lastName.value) ) {
                addErrorClass(lastName, 'Please fill in your last name');
              }
            }
            if (phone) {
              if ( isEmpty(phone.value) ) {
                addErrorClass(phone, 'Please fill in your phone number');
              } else if ( !isValidPhone(phone.value)) {
                addErrorClass(phone, 'Please fill in a valid phone number');
              }
            }
            if (company) {
              if ( isEmpty(company.value) ) {
                addErrorClass(company, 'Please fill in your company');
              }
            }
            if (email) {
              if ( isEmpty(email.value) ) {
                addErrorClass(email, 'Please fill in your email');
              } else if ( !isValidEmail(email.value) ) {
                addErrorClass(email, 'Please fill in a valid email');
              }
            }
            if (enquiryType) {
              if ( isEmpty(enquiryType.value) ) {
                addErrorClass(enquiryType, 'Please fill in your enquiry type');
              }
  
              if (enquiryType.value == 'New project') {
                if (budget) {
                  if (isEmpty(budget.value) || budget.value == 0 || !budget.classList.contains('has__value')) {
                    addErrorClass(budget, 'Please fill in your budget');
                  }
                }
              }
            }
            if (services) {
              for (let i = 0; i < services.length; i++) {
                // console.log(services[i].value);
                servicesValues.push(services[i].value);
              }
            }
            if (privacy) {
              if ( !privacy.checked ) {
                addErrorClass(privacy, 'Please agree to the Messy Collective privacy policy');
              }
            }
      
            if (countError > 0) {
              gsap.to(window, {
                scrollTo: '#contact',
              });
            } else {
      
              button.setAttribute('disabled', true);
              button.classList.add('loading');
        
              let data = {
                'action' : 'submit_contact_form',
                'g-recaptcha-response' : recaptcha.value,
                'form_type' : formType.value,
                'nonce' : nonce.value,
                'first_name' : firstName ? firstName.value : '',
                'last_name' : lastName ? lastName.value : '',
                'email' : email ? email.value : '',
                'company' : company ? company.value : '',
                'phone' : phone ? phone.value : '',
                'message' : message ? message.value : '',
                'business_type' : businessType ? businessType.value : '',
                'enquiry_type' : enquiryType ? enquiryType.value : '',
                'services' : servicesValues,
                'budget' : budget ? budget.value : '',
                'adwords_type' : adwordsType ? adwordsType.value : '',
              };
  
              $.ajax({
                type: 'POST',
                url: '/wp/wp-admin/admin-ajax.php',
                data: data,
                success: function(response, textStatus, xhr) {
                  if (xhr.status === 200) {
  
                    // console.log(response);
                    button.classList.remove('loading');

                    contactForm.classList.add('hide-form');
                    successDialog.classList.remove('is-hidden');
  
                    gsap.to(window, {
                      scrollTo: '#contact',
                    });
  
                    window.dataLayer.push({
                      'event': 'formSubmitSuccess',
                    });
  
                  } else {
                    // console.log(response);

                    button.classList.remove('loading');
                    button.setAttribute('disabled', '');
  
                    gsap.to(window, {
                      scrollTo: '#contact',
                    });
                  }
                },
                error: function(error) {
                  console.log(error);

                  button.classList.remove('loading');
                  button.setAttribute('disabled', '');
                },
              });
            }
          });
        });
  
      });
    }
    
    let cosDownloadForm = document.querySelector('form.cos__form');

    if (cosDownloadForm) {
      cosDownloadForm.addEventListener('change', function(e) {
        formAbandon.push(e.target.getAttribute(formAttribute));

        window.dataLayer.push({
          'event' : 'formInteraction',
          'eventCategory' : 'Form Interaction',
          'eventAction' : 'City of Sydney - Resource Form',
          'eventLabel' : e.target.getAttribute(formAttribute),
        });
      });

      cosDownloadForm.addEventListener('submit', (e) => {
        e.preventDefault();
  
        window.grecaptcha.ready(function() {
          window.grecaptcha.execute('6LeONPYUAAAAAOCBFJO2SdIXOW4nBsb-FvjDwsRD', {action: 'submitForm'})
          .then(function(token) {
            document.getElementById('side-g-recaptcha-response').value = token;
  
            let countError = 0;
      
            let removeError = (e) => {
              e.target.parentElement.classList.remove('has-error');
              e.target.removeEventListener('click', removeError);
            };
      
            let addErrorClass = (element, msg) => {
              countError = ++countError;
              element.parentElement.classList.add('has-error');
              element.parentElement.parentElement.querySelector('.form__error').textContent = msg;
              element.addEventListener('click', removeError);
            };
      
            let downloadBtn = document.querySelector('.btn__download-success');
            let downloadDialog = document.querySelector('.form__download-success');
            let recaptchaPolicy = document.querySelector('.form__recaptcha-policy');
            let submitFormBtn = document.querySelector('.btn__submit-form');
      
            let nonce = cosDownloadForm.querySelector('input[name=nonce]');
            let cosTag = cosDownloadForm.querySelector('input[name=cos-form]');
            let recaptcha = cosDownloadForm.querySelector('input[name=g-recaptcha-response]');
            let firstName = cosDownloadForm.querySelector('input[name=first-name]');
            let lastName = cosDownloadForm.querySelector('input[name=last-name]');
            let company = cosDownloadForm.querySelector('input[name=company]');
            let email = cosDownloadForm.querySelector('input[name=email]');
            let phone = cosDownloadForm.querySelector('input[name=phone]');
            let businessType = cosDownloadForm.querySelector('input[name=business-type]');
            let privacy = cosDownloadForm.querySelector('input[name=privacy]');
            let button = cosDownloadForm.querySelector('button[type=submit]');
      
            if (firstName) {
              if ( isEmpty(firstName.value) ) {
                addErrorClass(firstName, 'Please fill in your first name');
              }
            }
            if (lastName) {
              if ( isEmpty(lastName.value) ) {
                addErrorClass(lastName, 'Please fill in your last name');
              }
            }
            if (phone) {
              if ( isEmpty(phone.value) ) {
                addErrorClass(phone, 'Please fill in your phone number');
              } else if ( !isValidPhone(phone.value)) {
                addErrorClass(phone, 'Please fill in a valid phone number');
              }
            }
            if (company) {
              if ( isEmpty(company.value) ) {
                addErrorClass(company, 'Please fill in your company');
              }
            }
            if (email) {
              if ( isEmpty(email.value) ) {
                addErrorClass(email, 'Please fill in your email');
              } else if ( !isValidEmail(email.value) ) {
                addErrorClass(email, 'Please fill in a valid email');
              }
            }
            if (privacy) {
              if ( !privacy.checked ) {
                addErrorClass(privacy, 'Please agree to the Messy Collective privacy policy');
              }
            }
      
            if (countError > 0) {
              gsap.to(window, {
                scrollTo: '#side-form',
              });
            } else {
      
              button.setAttribute('disabled', true);
              button.classList.add('loading');

              let data = {
                'action' : 'submit_cos_download_form',
                'g-recaptcha-response' : recaptcha.value,
                'cos_resource_tag': cosTag.value,
                'nonce' : nonce.value,
                'first_name' : firstName ? firstName.value : '',
                'last_name' : lastName ? lastName.value : '',
                'email' : email ? email.value : '',
                'company' : company ? company.value : '',
                'phone' : phone ? phone.value : '',
                'business_type' : businessType ? businessType.value : '',
              };
  
              $.ajax({
                type: 'POST',
                url: '/wp/wp-admin/admin-ajax.php',
                data: data,
                success: function(response, textStatus, xhr) {
                  
                  if (xhr.status === 200) {
  
                    button.classList.remove('loading');

                    downloadDialog.classList.remove('is-hidden');
                    downloadBtn.classList.remove('is-hidden');
                    submitFormBtn.classList.add('is-hidden');
                    recaptchaPolicy.classList.add('is-hidden');

                    downloadBtn.querySelector('.download-btn').href = response.data;

                    window.dataLayer.push({
                      'event': 'downloadCosResource',
                      'resource': cosTag.value,
                    });
  
                  } else {

                    button.classList.remove('loading');
                    button.setAttribute('disabled', false);
  
                    gsap.to(window, {
                      scrollTo: '#side-form',
                    });
                  }
                },
                error: function(error) {
                  console.log(error);
                },
              });
            }
          });
        });
  
      });
    }

    let adwordsForm = document.querySelector('form.adwords__form');

    if (adwordsForm) {
      let adwordsType = adwordsForm.querySelector('input[name=adwords-type]');

      adwordsForm.addEventListener('change', function(e) {
        formAbandon.push(e.target.getAttribute(formAttribute));

        window.dataLayer.push({
          'event' : 'formInteraction',
          'eventCategory' : 'Form Interaction',
          'eventAction' : adwordsType.value + 'landing page form',
          'eventLabel' : e.target.getAttribute(formAttribute),
        });
      });

      adwordsForm.addEventListener('submit', (e) => {
        e.preventDefault();
  
        window.grecaptcha.ready(function() {
          window.grecaptcha.execute('6LeONPYUAAAAAOCBFJO2SdIXOW4nBsb-FvjDwsRD', {action: 'submitForm'})
          .then(function(token) {
            document.getElementById('side-g-recaptcha-response').value = token;
  
            let countError = 0;
      
            let removeError = (e) => {
              e.target.parentElement.classList.remove('has-error');
              e.target.removeEventListener('click', removeError);
            };
      
            let addErrorClass = (element, msg) => {
              countError = ++countError;
              element.parentElement.classList.add('has-error');
              element.parentElement.parentElement.querySelector('.form__error').textContent = msg;
              element.addEventListener('click', removeError);
            };

            let successDialog = document.querySelector('.side-form-container .form__success');
      
            let nonce = adwordsForm.querySelector('input[name=nonce]');
            let recaptcha = adwordsForm.querySelector('input[name=g-recaptcha-response]');
            let firstName = adwordsForm.querySelector('input[name=first-name]');
            let lastName = adwordsForm.querySelector('input[name=last-name]');
            let email = adwordsForm.querySelector('input[name=email]');
            let phone = adwordsForm.querySelector('input[name=phone]');
            let privacy = adwordsForm.querySelector('input[name=privacy]');
            let button = adwordsForm.querySelector('button[type=submit]');
      
            if (firstName) {
              if ( isEmpty(firstName.value) ) {
                addErrorClass(firstName, 'Please fill in your first name');
              }
            }
            if (lastName) {
              if ( isEmpty(lastName.value) ) {
                addErrorClass(lastName, 'Please fill in your last name');
              }
            }
            if (phone) {
              if ( isEmpty(phone.value) ) {
                addErrorClass(phone, 'Please fill in your phone number');
              } else if ( !isValidPhone(phone.value)) {
                addErrorClass(phone, 'Please fill in a valid phone number');
              }
            }
            if (email) {
              if ( isEmpty(email.value) ) {
                addErrorClass(email, 'Please fill in your email');
              } else if ( !isValidEmail(email.value) ) {
                addErrorClass(email, 'Please fill in a valid email');
              }
            }
            if (privacy) {
              if ( !privacy.checked ) {
                addErrorClass(privacy, 'Please agree to the Messy Collective privacy policy');
              }
            }
      
            if (countError > 0) {
              gsap.to(window, {
                scrollTo: '#side-form',
              });
            } else {
      
              button.setAttribute('disabled', true);
              button.classList.add('loading');

              let data = {
                'action' : 'submit_adwords_form',
                'g-recaptcha-response' : recaptcha.value,
                'nonce' : nonce.value,
                'first_name' : firstName ? firstName.value : '',
                'last_name' : lastName ? lastName.value : '',
                'email' : email ? email.value : '',
                'phone' : phone ? phone.value : '',
                'adwords_type' : adwordsType ? adwordsType.value : '',
              };
  
              $.ajax({
                type: 'POST',
                url: '/wp/wp-admin/admin-ajax.php',
                data: data,
                success: function(response, textStatus, xhr) {
                  
                  if (xhr.status === 200) {
  
                    button.classList.remove('loading');

                    adwordsForm.classList.add('hide-form');
                    successDialog.classList.remove('is-hidden');

                    window.dataLayer.push({
                      'event': 'submitLandingPageFormHeader',
                      'resource': adwordsType.value,
                    });

                    gsap.to(window, {
                      scrollTo: '#side-form',
                    });
  
                  } else {

                    button.classList.remove('loading');
                    button.setAttribute('disabled', false);
  
                    gsap.to(window, {
                      scrollTo: '#side-form',
                    });
                  }
                },
                error: function(error) {
                  console.log(error);
                },
              });
            }
          });
        });
  
      });
    }

    let isEmpty = (str) => {
      return (!str || 0 === str.length);
    };

    let isValidEmail = (str) => {
      const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // console.log(reg.test(str));
      return reg.test(str);
    };

    let isValidPhone = (str) => {
      const reg = /(\(+61\)|\+61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){6,9}/;
      // console.log(reg.test(str));
      return reg.test(str);
    };

    const ranges = document.querySelectorAll('.form__range');

    // Create our number formatter.
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    ranges.forEach(wrap => {
      const range = wrap.querySelector('input[type=range]');
      const bubble = wrap.querySelector('.form__bubble');

      range.addEventListener('input', () => {
        setBubble(range, bubble);
        range.setAttribute('value', range.value);
        range.classList.add('has__value');
      });

      // setBubble(range, bubble);
    });

    function setBubble(range, bubble) {
      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      if (val == range.max) {
        bubble.innerHTML = formatter.format(val) + '+';
      } else {
        bubble.innerHTML = formatter.format(val);
      }

      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;

    }


    let navBg = document.querySelector('.nav-background');
    let nav = document.querySelector('.nav-primary');
    let navToggle = document.querySelector('.nav-toggle');

    let open, close;

    if (navToggle) {
      open = navToggle.querySelector('[data-nav-open]');
      close = navToggle.querySelector('[data-nav-close]');
    }

    let navMenuContainer = document.querySelector('.nav_menu--mobile');
    let navMenu;
    if (navMenuContainer) {
      navMenu = navMenuContainer.querySelector('.nav_menu');
    }

    //let menuLinks = document.querySelectorAll('.menu-item');

    let navContent = document.querySelector('.nav-content');
    let navSocial = document.querySelector('.nav-social');

    let initNav = () => {
      if (navToggle) {
        navToggle.addEventListener('click', () => {
          if (navToggle.classList.contains('open')) {
            navToggle.classList.remove('open');
            closeMenu();
          } else {
            navToggle.classList.add('open');
            openMenu();
          }
        });
      }
    }

    let setNav = () => {
      if (navToggle) {
        navToggle.classList.remove('open');
        gsap.set(navBg, {
          autoAlpha: 0,
          display: 'none',
        });
        gsap.set(navMenu, {
          autoAlpha: 0,
          display: 'none',
        });
        gsap.set(navContent, {
          autoAlpha: 0,
          display: 'none',
        });
        gsap.set(navSocial, {
          autoAlpha: 0,
          display: 'none',
        });
        gsap.set(close, {
          autoAlpha: 0,
          display: 'none',
        });
        gsap.set(open, {
          autoAlpha: 1,
          display: 'block',
        });
      }
    }

    setNav();
    initNav();

    let menuLinks = document.querySelectorAll('.menu-item');
    menuLinks.forEach(link => {
      link.addEventListener('click', () => {
        closeMenu();
      });
    });
/**
    menuLinks.forEach(link => {
      var clicked = 0;
      link.addEventListener('click', (e) => {
        closeMenu();
        e.preventDefault();
        let href = e.srcElement.hash;
        gsap.to(window, {
          duration: 1,
          scrollTo: href,
          // delay: 0.25,
        });
        if(clicked == 0) {
          clicked ++;
          link.click();
        }
      });
    });
**/
/**    let heroLink = document.querySelectorAll('.hero-link');
    heroLink.forEach(hl => {
      var clicked = 0;
      hl.addEventListener('click', (e) => {
        e.preventDefault();
        let href = e.srcElement.hash;
        gsap.to(window, {
          duration: 1,
          scrollTo: href,
          // delay: 0.25,
        });
        if(clicked == 0) {
          clicked ++;
          hl.click();
        }
      });
    });
**/
    let reset = () => {
      if (window.innerWidth >= 1024) {
        clearAllBodyScrollLocks();
        setNav();
      }
    }

    const throttleNav = _.throttle(reset, 300);

    window.addEventListener('resize', throttleNav);

    let closeMenu = () => {
      clearAllBodyScrollLocks();
      navToggle.classList.remove('open');
      gsap.fromTo(open, {
        display: 'block',
      },{
        autoAlpha: 1,
      });
      gsap.to(close, {
        display: 'none',
        autoAlpha: 0,
      });
      gsap.to(navBg, {
        display: 'none',
        autoAlpha: 0,
      });
      gsap.to(navMenu, {
        display: 'none',
        autoAlpha: 0,
      });
      gsap.to(navMenuContainer, {
        autoAlpha: 0,
        display: 'none',
      });
      gsap.to(navContent, {
        autoAlpha: 0,
        display: 'none',
      });
      gsap.to(navSocial, {
        autoAlpha: 0,
        display: 'none',
      });
    }

    let openMenu = () => {
      disableBodyScroll(nav);
      gsap.fromTo(close, {
        display: 'block',
      },{
        autoAlpha: 1,
      });
      gsap.to(open, {
        display: 'none',
        autoAlpha: 0,
      });
      gsap.fromTo(navBg, {
        display: 'block',
      },{
        autoAlpha: 1,
      });
      gsap.fromTo(navMenuContainer, {
        display: 'block',
      }, {
        autoAlpha: 1,
      });
      gsap.fromTo(navMenu, {
        display: 'inline-flex',
        scale: 1.2,
        x: '-=' + 25,
        y: '+=' + 25,
      },{
        x: 0,
        y: 0,
        autoAlpha: 1,
        scale: 1,
        delay: 0.5,
        duration: 0.3,
        ease: 'sine.inOut',
      });
      gsap.fromTo(navContent, {
        display: 'block',
        scale: 1.2,
        x: '-=' + 25,
        y: '+=' + 25,
      },{
        x: 0,
        y: 0,
        autoAlpha: 1,
        scale: 1,
        delay: 0.5,
        duration: 0.3,
        ease: 'sine.inOut',
      });
      gsap.fromTo(navSocial, {
        display: 'inline-flex',
      },{
        autoAlpha: 1,
        delay: 0.5,
        duration: 0.3,
        ease: 'sine.inOut',
      });
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(document).ready(function(){
      $(window).bind('scroll', function() {
        var scrollTop = $(window).scrollTop();
        if(scrollTop > 100) {
          $('.nav-container').addClass('sticky');
        } else {
          $('.nav-container').removeClass('sticky');
        }
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js